import {today} from 'common/date';
import * as React from 'react';

/**
 * The current calendar day (ISO date), refreshed whenever the tab regains
 * focus — a view left mounted across midnight (or resumed days later) must
 * not keep deriving windows from a stale "now".
 */
export const useDayKey = (): string => {
  const [dayKey, setDayKey] = React.useState(() => today().toISODate() ?? '');
  React.useEffect(() => {
    const refresh = () => {
      setDayKey((prev) => today().toISODate() ?? prev);
    };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return dayKey;
};
